export  function lookResetCodeInUrl(url){
  let qparams=url.slice(1)
let queryParams =qparams && qparams.split('&')[0].split('=')[1] === "true" ? true :false
let queryCode =qparams && qparams.split('&')[1].split('=')[1]
  return {
    isResetUrl:queryParams,
    resetCode:queryCode
  }
}